"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _Loader = _interopRequireDefault(require("../v1/components/Loader/Loader"));
var _TextInputPropTypes = _interopRequireDefault(require("./TextInputPropTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class TextInput extends _react.Component {
  static defaultProps = {
    type: 'text',
    maskChar: null,
    iconPosition: 'left'
  };
  state = {
    validationState: null
  };
  componentDidMount() {
    this._input?.getInputDOMNode()?.addEventListener('invalid', this._onInvalid);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.focus !== this.props.focus) {
      this._checkFocus();
    }
  }
  componentWillUnmount() {
    this._input?.getInputDOMNode()?.removeEventListener('invalid', this._onInvalid);
  }
  _onInvalid = evt => {
    evt.preventDefault();
    const {
      onInvalid
    } = this.props;
    const validationState = evt.currentTarget.validity;
    this.setState({
      validationState
    });
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  _onChange = evt => {
    const {
      onChange
    } = this.props;
    this.setState({
      validationState: null
    });
    if (onChange) {
      onChange(evt);
    }
  };
  _checkFocus() {
    if (this.props.focus) {
      this._input?.getInputDOMNode()?.focus();
    }
  }

  /**
   * Getter for the input DOM element.
   *
   * @public
   * @returns {Element} - The input element.
   */
  get node() {
    return this._input?.getInputDOMNode();
  }
  render() {
    const {
      className,
      name,
      type,
      label,
      placeholder,
      pattern,
      required,
      disabled,
      loading,
      autoFocus,
      error,
      defaultValue,
      icon,
      iconPosition,
      helpNode,
      inline,
      readOnly,
      maxLength,
      min,
      max,
      mask,
      maskChar,
      additionalInputProps,
      onFocus,
      onBlur,
      'aria-label': ariaLabel
    } = this.props;
    const {
      validationState
    } = this.state;
    const isValid = validationState ? validationState.valid : true;
    const classes = (0, _classnames.default)('TextInput', 'FormElement', {
      'FormElement-inline': inline
    }, {
      'FormElement-with-icon': icon
    }, {
      'FormElement-loading': loading
    }, {
      [`FormElement-with-icon-${iconPosition}`]: icon
    }, {
      'FormElement-contains-error': !isValid
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, label, /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-control"
    }, /*#__PURE__*/_react.default.createElement(_reactInputMask.default, (0, _extends2.default)({
      ref: node => {
        this._input = node;
      },
      className: "FormElement-item",
      name: name,
      type: type,
      placeholder: placeholder,
      disabled: disabled,
      autoFocus: autoFocus,
      required: required,
      pattern: pattern,
      maxLength: maxLength,
      min: min,
      max: max,
      onChange: this._onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      mask: mask,
      maskChar: maskChar,
      alwaysShowMask: false,
      readOnly: readOnly,
      defaultValue: defaultValue,
      "aria-label": ariaLabel || null
    }, additionalInputProps)), icon, loading && /*#__PURE__*/_react.default.createElement(_Loader.default, {
      size: 16,
      borderWidth: 2
    })), helpNode && /*#__PURE__*/_react.default.createElement("div", {
      className: "FormElement-help-text"
    }, helpNode), !isValid && error);
  }
}
exports.default = TextInput;